// Single source of truth for admin-facing network display names.
//
// These labels used to be copy-pasted into ~15 components, so a rebrand (e.g.
// RGA -> LD) meant editing every copy and silently missing some. Import from
// here instead; a label change is now one line.
//
// Colors stay per-component on purpose — the chip palette legitimately differs
// by view, so it is not centralized here.
//
// Network KEYS (rga_vishy / rga_ashok / ...) and outbound literals are never
// touched; only the human-readable label is. Publishers never see this map —
// the backend white-labels every RGA network to "ld" via public_network()
// before any publisher-facing payload.

export const NETWORK_LABELS = {
  impact: "Impact",
  partnerize: "Partnerize",
  skimlinks: "Skimlinks",
  mrge: "mrge",
  cj: "CJ",
  admedia: "AdMedia",
  pubadhub: "PubAdHub",
  pubadhub_kevin: "PubAdHub Kevin",
  flexoffers: "FlexOffers",
  shopnomix: "Shopnomix",
  shopnomix_kevin: "Shopnomix Kevin",
  pronomix: "Pronomix",
  siteplug: "Siteplug",
  giddyup: "GiddyUp",
  coinis: "Coinis",
  yieldkit: "Yieldkit",
  maxbounty: "MaxBounty",
  cashbackhive: "CashbackHive",
  fatcoupon: "FatCoupon",
  rga: "LD (both accounts)",
  rga_vishy: "LD Kevin",
  rga_ashok: "LD Ashok",
};

// Full display label for a network key. Falls back to the raw value (as the
// old per-file `MAP[x] || x` lookups did).
export function networkLabel(network) {
  const n = (network || "").toLowerCase();
  if (!n) return "";
  return NETWORK_LABELS[n] || network;
}

// Compact label for the small color chips (NetworkPill). A few long names are
// abbreviated; everything else shows its lowercased key (the chips are
// uppercased in CSS). The RGA accounts carry their white-labeled LD names so
// no chip ever renders the raw rga_vishy / rga_ashok key.
const PILL_SHORT = {
  pubadhub_kevin: "pah-kevin",
  shopnomix_kevin: "sn-kevin",
  rga: "LD",
  rga_vishy: "LD Kevin",
  rga_ashok: "LD Ashok",
};

export function networkPillLabel(network) {
  const n = (network || "").toLowerCase();
  if (!n) return "";
  return PILL_SHORT[n] || n;
}
